import { ref } from '@nuxtjs/composition-api';
import useBrandConfig from '@shared/composables/useBrandConfig';
import { VehicleSidebarState } from '@shared/system-constants';

const state = ref<VehicleSidebarState>(VehicleSidebarState.CLOSED);

export interface UseVehiclesSidebarConfig {
  defaultOpenState: VehicleSidebarState;
}

const useVehiclesSidebar = () => {
  const { composableConfig } = useBrandConfig();
  const config = composableConfig.useVehiclesSidebar;
  const open = (view?: VehicleSidebarState) => (state.value = view ?? config.defaultOpenState);

  const close = () => (state.value = VehicleSidebarState.CLOSED);

  const setView = (view: VehicleSidebarState) => (state.value = view);

  return {
    state,
    open,
    close,
    setView,
  };
};
export default useVehiclesSidebar;
